import { gql } from 'apollo-boost';

import { ValidationErrorFragment, ValidationWarningFragment } from './common';

export const updateCampaigns = gql`
    mutation UpdateCampaigns($input: GdUpdateCampaignsInput!, $login: String!) {
        reqId: getReqId
        updateCampaigns(input: $input) {
            updatedCampaigns {
                id
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;
